// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"pq-z","breadcrumbForward":"qq-z","breadcrumbBack":"rq-z","selected":"sq-z"};